var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmanAppAdvertiseAppleStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226.52,
    height: 85,
    viewBox: "0 0 226.52 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-3{fill:#fff}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1777",
    transform: "translate(-1025.781 -5186.652)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1957",
    width: 226,
    height: 85,
    fill: "#f37021",
    rx: 9,
    transform: "translate(1025.781 5186.652)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "iOS_App",
    transform: "translate(1220.909 -3377.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    fill: "#fff",
    d: "M218.006 1.7a6.394 6.394 0 0 1 4.981 2.611 10.24 10.24 0 0 1 2.063 6.3v63.673a10.24 10.24 0 0 1-2.063 6.3 6.394 6.394 0 0 1-4.981 2.611H8.385A6.394 6.394 0 0 1 3.4 80.588a10.239 10.239 0 0 1-2.063-6.3V10.612A10.237 10.237 0 0 1 3.4 4.308 6.393 6.393 0 0 1 8.385 1.7zm0-1.7H8.385a7.611 7.611 0 0 0-5.928 3.113A12.188 12.188 0 0 0 0 10.612v63.672a12.188 12.188 0 0 0 2.456 7.5A7.611 7.611 0 0 0 8.385 84.9h209.621a7.611 7.611 0 0 0 5.929-3.113 12.189 12.189 0 0 0 2.456-7.5V10.612a12.19 12.19 0 0 0-2.456-7.5A7.611 7.611 0 0 0 218.006 0z",
    opacity: 0.3,
    transform: "translate(-195 8564)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    transform: "translate(-168.848 8583.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    d: "M52.653 31.445a9.262 9.262 0 0 1 4.412-7.772 9.48 9.48 0 0 0-7.472-4.04c-3.143-.331-6.192 1.88-7.794 1.88-1.633 0-4.1-1.849-6.756-1.794a9.947 9.947 0 0 0-8.372 5.107c-3.621 6.268-.92 15.481 2.547 20.548 1.735 2.482 3.762 5.252 6.417 5.155 2.6-.108 3.567-1.655 6.7-1.655 3.1 0 4.016 1.655 6.722 1.593 2.786-.045 4.541-2.493 6.216-5a20.507 20.507 0 0 0 2.843-5.789 8.954 8.954 0 0 1-5.463-8.233z",
    className: "cls-3",
    transform: "translate(-24.951 -9.767)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    d: "M46.774 16.752a9.116 9.116 0 0 0 2.087-6.534 9.288 9.288 0 0 0-6.005 3.113 8.676 8.676 0 0 0-2.141 6.292 7.672 7.672 0 0 0 6.059-2.871z",
    className: "cls-3",
    transform: "translate(-24.187 -10.218)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    d: "M88.058 49.744h-3.629L82.448 43.5h-6.916l-1.895 6.246H70.1l6.851-21.266h4.228zm-6.214-8.866l-1.8-5.552q-.283-.849-1.073-4.006h-.064q-.314 1.357-1.01 4.006l-1.766 5.552z",
    className: "cls-3",
    transform: "translate(-22.781 -9.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    d: "M104.705 41.631a8.716 8.716 0 0 1-2.114 6.182 6.183 6.183 0 0 1-4.7 2.019 4.7 4.7 0 0 1-4.354-2.182h-.064v8.078h-3.408V39.2q0-2.459-.126-5.047h3l.19 2.431h.064a6.062 6.062 0 0 1 9.7-.6 8.451 8.451 0 0 1 1.812 5.647zm-3.471.125a6.315 6.315 0 0 0-1.009-3.692 3.488 3.488 0 0 0-2.971-1.515 3.537 3.537 0 0 0-2.287.836 3.877 3.877 0 0 0-1.341 2.195 4.459 4.459 0 0 0-.158 1.039v2.557a4.1 4.1 0 0 0 1.026 2.83 3.4 3.4 0 0 0 2.666 1.152 3.488 3.488 0 0 0 3-1.487 6.526 6.526 0 0 0 1.073-3.914z",
    className: "cls-3",
    transform: "translate(-21.826 -9.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    d: "M121.532 41.631a8.708 8.708 0 0 1-2.122 6.182 6.175 6.175 0 0 1-4.7 2.019 4.7 4.7 0 0 1-4.352-2.176h-.064v8.078h-3.406V39.2q0-2.459-.127-5.047h3l.19 2.431h.064a6.063 6.063 0 0 1 9.7-.6 8.471 8.471 0 0 1 1.817 5.647zm-3.471.125a6.308 6.308 0 0 0-1.012-3.692 3.481 3.481 0 0 0-2.963-1.515 3.549 3.549 0 0 0-2.289.836 3.877 3.877 0 0 0-1.339 2.195 4.554 4.554 0 0 0-.158 1.039v2.557a4.1 4.1 0 0 0 1.023 2.83 3.407 3.407 0 0 0 2.669 1.152 3.486 3.486 0 0 0 3-1.483 6.526 6.526 0 0 0 1.075-3.918z",
    className: "cls-3",
    transform: "translate(-21.018 -9.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    d: "M140.268 43.8a5.667 5.667 0 0 1-1.889 4.416 8.371 8.371 0 0 1-5.791 1.862 10.141 10.141 0 0 1-5.511-1.324l.79-2.84a9.339 9.339 0 0 0 4.924 1.358 4.658 4.658 0 0 0 3-.869 2.84 2.84 0 0 0 1.07-2.323 2.96 2.96 0 0 0-.883-2.179 8.207 8.207 0 0 0-2.933-1.644q-5.585-2.083-5.582-6.1a5.4 5.4 0 0 1 1.957-4.3 7.717 7.717 0 0 1 5.206-1.674 10.321 10.321 0 0 1 4.825 1.01l-.849 2.778a8.369 8.369 0 0 0-4.071-.971 4.117 4.117 0 0 0-2.806.884 2.523 2.523 0 0 0-.849 1.926 2.6 2.6 0 0 0 .976 2.081 11.052 11.052 0 0 0 3.094 1.641 10.492 10.492 0 0 1 4.037 2.585 5.4 5.4 0 0 1 1.285 3.683z",
    className: "cls-3",
    transform: "translate(-20.041 -9.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    d: "M150.839 36.87h-3.754v7.444q0 2.84 1.981 2.84A6.06 6.06 0 0 0 150.58 47l.095 2.587a7.726 7.726 0 0 1-2.65.378 4.088 4.088 0 0 1-3.155-1.231 6.045 6.045 0 0 1-1.132-4.134v-7.73H141.5v-2.56h2.237V31.5l3.346-1.01v3.82h3.755z",
    className: "cls-3",
    transform: "translate(-19.346 -9.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    d: "M167.267 41.7a8.409 8.409 0 0 1-2.019 5.8 7.216 7.216 0 0 1-5.619 2.335 6.858 6.858 0 0 1-5.377-2.238 8.156 8.156 0 0 1-2-5.647 8.327 8.327 0 0 1 2.066-5.835 7.15 7.15 0 0 1 5.566-2.272 7 7 0 0 1 5.426 2.24 8.065 8.065 0 0 1 1.96 5.617zm-3.537.11a6.9 6.9 0 0 0-.914-3.638 3.365 3.365 0 0 0-3.059-1.839 3.416 3.416 0 0 0-3.123 1.839 7.028 7.028 0 0 0-.914 3.7 6.885 6.885 0 0 0 .914 3.636 3.482 3.482 0 0 0 6.152-.033 6.923 6.923 0 0 0 .947-3.669z",
    className: "cls-3",
    transform: "translate(-18.831 -9.085)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    d: "M177.517 37.148a5.927 5.927 0 0 0-1.074-.095 3.218 3.218 0 0 0-2.776 1.358 5.106 5.106 0 0 0-.849 3.028v8.05h-3.41l.033-10.5q0-2.652-.127-4.828h2.971l.125 2.933h.095a5.235 5.235 0 0 1 1.7-2.429 4.118 4.118 0 0 1 2.462-.821 5.481 5.481 0 0 1 .849.062z",
    className: "cls-3",
    transform: "translate(-18.007 -9.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    d: "M192.3 41.1a7.978 7.978 0 0 1-.125 1.545H181.96a4.447 4.447 0 0 0 1.483 3.472 5.063 5.063 0 0 0 3.342 1.073 11.3 11.3 0 0 0 4.134-.726l.535 2.364a12.791 12.791 0 0 1-5.14.948 7.448 7.448 0 0 1-5.6-2.1 7.751 7.751 0 0 1-2.033-5.631 8.784 8.784 0 0 1 1.895-5.773 6.529 6.529 0 0 1 5.361-2.459 5.713 5.713 0 0 1 5.019 2.459A8.3 8.3 0 0 1 192.3 41.1zm-3.254-.884a4.62 4.62 0 0 0-.661-2.619 2.971 2.971 0 0 0-2.715-1.415 3.232 3.232 0 0 0-2.711 1.388 5.085 5.085 0 0 0-1.009 2.649h7.1z",
    className: "cls-3",
    transform: "translate(-17.561 -9.085)"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "\\u0645\\u062A\\u0648\\u0641\\u0631_\\u0639\\u0644\\u0649",
    fill: "#fff",
    fontFamily: "HelveticaNeueLTArabic-Bold, Helvetica Neue Arabic",
    fontSize: "14px",
    fontWeight: 700,
    transform: "translate(1131.781 5214.652)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.665,
    y: 0
  }, "\u0645\u062A\u0648\u0641\u0631 \u0639\u0644\u0649")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmanAppAdvertiseAppleStore);
export default __webpack_public_path__ + "static/media/amanApp-advertise-apple-store.f22b5cd4a0e3e9943d165a91ed4de0e8.svg";
export { ForwardRef as ReactComponent };